// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const ExportSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M10.4771 3.33564C10.6669 3.12215 10.9389 3 11.2245 3H12.7755C13.0611 3 13.3331 3.12215 13.5229 3.33564L17.3737 7.66782L16.6263 8.33218L12.7755 4H12.5V16H11.5V4H11.2245L7.3737 8.33218L6.6263 7.66782L10.4771 3.33564ZM3 19V14H4V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V14H21V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19Z" />
    </svg>
  )
}
